import React, { useState, useEffect } from "react";
import './Resignform.css';
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const Resignform = () => {
  const [formData, setFormData] = useState({
    empId: "",
    empName: "",
    reason: "",
    date: "",
    noticePeriodDate: "",
    feedback: "",
  });
  const [existingData, setExistingData] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const isFormValid = formData.empId && formData.empName && formData.reason && formData.date && formData.resignEndDate;

  const fetchExistingResignation = async (empId, empName) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/resign/employee/${empId}`);
      if (response.data && response.data.length > 0) {
        setExistingData(response.data[0]);
      } else {
        setFormData((prevData) => ({
          ...prevData,
          empId: empId,
          empName: empName,
        }));
      }
    } catch (error) {
      console.error("Error fetching resignation data:", error);
      setFormData((prevData) => ({
        ...prevData,
        empId: empId,
        empName: empName,
      }));
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

   const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      employeeId: formData.empId,
      reason: formData.reason,
      lastDate: formData.date,
      noticePeriodDate: formData.resignEndDate,
      feedback: formData.feedback,
      
    };

    console.log("Submitting payload:", payload);

    try {
      // Base API URL from environment variable or fallback to localhost
      const baseUrl = process.env.REACT_APP_API_BASE_URL;

      if (isUpdating && existingData?.rid) {
        // Update existing resignation
        const response = await axios.put(`${baseUrl}/api/resign/${existingData.rid}`, payload);
        alert("Resignation updated successfully.");
        setIsUpdating(false);
        setExistingData(response.data);
      } else {
        // Submit new resignation
        const response = await axios.post(`${baseUrl}/api/resignations`, payload);
        alert("Resignation submitted successfully.");
      }

      // Reset form
      setFormData({
        empId: "",
        empName: "",
        reason: "",
        date: "",
        resignEndDate: "",
        feedback: "",
      });

    } catch (error) {
      console.error("Submission failed:", error.response?.data || error.message);
      alert("Failed to submit or update. Please try again.");
    }
  };


  const handleEditClick = () => {
    if (existingData) {
      setFormData({
        empId: existingData.employeeId,
        empName: existingData.employeeName,
        reason: existingData.reason,
        lastDate: existingData.lastDate,
        noticePeriodDate: existingData.noticePeriodDate,
        feedback: existingData.feedback,
      });
      setIsUpdating(true);
    }
  };
  useEffect(() => {
    if (formData.date) {
      const resignationDate = new Date(formData.date);
      const endDate = new Date(resignationDate);
      endDate.setDate(resignationDate.getDate() + 60);
      setFormData((prev) => ({
        ...prev,
        resignEndDate: endDate.toISOString().split("T")[0],
      }));
    }
  }, [formData.date]);


  useEffect(() => {
    const storedEmpId = localStorage.getItem("employeeId") || "N/A";
    const storedEmpName = localStorage.getItem("full_name") || "";
    fetchExistingResignation(storedEmpId, storedEmpName);
  }, []);

  return (
    <React.Fragment>
      <div className="resign-form-container">

        {existingData && !isUpdating ? (
          <div className="resignation-details ">
            <h3 className="empdata-head">Resignation Already Submitted</h3>
            <div className="empdata-row"><strong>Employee ID:</strong><span>{existingData.employeeId}</span></div>
            <div className="empdata-row"><strong>Name:</strong><span>{existingData.full_name}</span></div>
            <div className="empdata-row"><strong>Reason:</strong><span>{existingData.reason}</span></div>

            <div className="empdata-row"><strong>Resignation Date:</strong><span>{format(existingData.lastDate, "dd-MM-yyyy")}</span></div>
            <div className="empdata-row"><strong>Resignation End Date:</strong><span>{format(existingData.noticePeriodDate, "dd-MM-yyyy")}</span></div>
            <div className="empdata-row"><strong>Feedback:</strong><span>{existingData.feedback}</span></div>
            <div className="empdata-row"><strong>Status:</strong><span>{existingData.status}</span></div>
            <div className="empdata-row"><strong>RID:</strong><span>{existingData.rid}</span></div>

            {existingData.status === "request" && (
              <button onClick={handleEditClick}>Update</button>
            )}


          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2 className="empdata-head">Resignation Form</h2>
            <div className="floating-label">
              <input type="text" name="empId" value={formData.empId} onChange={handleChange} placeholder="" readOnly />
              <label>Employee ID</label>
            </div>
            <div className="floating-label">
              <input type="text" name="empName" value={formData.empName} onChange={handleChange} placeholder="" readOnly />
              <label>Employee Name</label>
            </div>
            <div className="floating-label">
              <input type="text" name="reason" value={formData.reason} onChange={handleChange} required placeholder="" />
              <label>Reason for Resignation</label>
            </div>
            <div className={`floating-label-datepicker ${formData.date ? "filled" : ""}`}>
              <DatePicker
                selected={formData.date ? new Date(formData.date) : null}
                onChange={(date) =>
                  handleChange({
                    target: {
                      name: "date",
                      value: date ? date.toLocaleDateString("en-CA") : "", // yyyy-MM-dd (safe format)
                    },
                  })
                }
                minDate={new Date()}
                dateFormat="dd-MM-yyyy"
                placeholderText=""
              />

              <label>Resignation Date</label>
            </div>
            <div className={`floating-label-datepicker ${formData.resignEndDate ? "filled" : ""}`}>
              <DatePicker
                selected={formData.resignEndDate ? new Date(formData.resignEndDate) : null}
                onChange={() => { }}
                dateFormat="dd-MM-yyyy"
                placeholderText=""
                disabled
              />
              <label>Notice Period</label>
            </div>
            <div className="floating-label">
              <textarea name="feedback" placeholder="" value={formData.feedback} onChange={handleChange} rows={3} />
              <label>Feedback</label>
            </div>

            <div className="resignform-buttons">
              <button type="submit" disabled={!isFormValid}>{isUpdating ? "Update" : "Submit"}</button>
            </div>
          </form>
        )}

      </div>
    </React.Fragment>
  );
};

export default Resignform;
